angular.module('impactx.controlChip', []);

var handleControlDataForChips = function (control) {
    var temp = [];
    if (control) {
        if (control.ctu) {
            for (var ctuDist = 0; ctuDist < control.ctu.set.length; ctuDist++) {
                var ctu = control.ctu.set[ctuDist];
                var ctuFromAllowed = control.ctu.allowed.entries.filter(function (obj) {
                    return obj.id === ctu.id;
                })[0];
                if (ctuFromAllowed) {
                    if (ctu.factor) {
                        ctuFromAllowed.factor = ctu.factor;
                    }
                    temp.push(ctuFromAllowed);
                }
            }
            control.ctu.set = temp;
        }
        if (control.prj) {
            temp = [];
            for (var prjDist = 0; prjDist < control.prj.set.length; prjDist++) {
                var prj = control.prj.set[prjDist];
                var prjFromAllowed = control.prj.allowed.entries.filter(function (obj) {
                    return obj.id === prj.id;
                })[0];

                if (prjFromAllowed) {
                    if (prj.factor) {
                        prjFromAllowed.factor = prj.factor;
                    }
                    temp.push(prjFromAllowed);
                }
            }
            control.prj.set = temp;
        }
        if (control.ctt) {
            temp = [];
            for (var cttDist = 0; cttDist < control.ctt.set.length; cttDist++) {
                var ctt = control.ctt.set[cttDist];
                var cttFromAllowed = control.ctt.allowed.entries.filter(function (obj) {
                    return obj.id === ctt.id;
                })[0];

                if (cttFromAllowed) {
                    if (ctt.factor) {
                        cttFromAllowed.factor = ctt.factor;
                    }
                    temp.push(cttFromAllowed);
                }
            }
            control.ctt.set = temp;
        }
        if (control.ctrlA) {
            temp = [];
            for (var ctrlADist = 0; ctrlADist < control.ctrlA.set.length; ctrlADist++) {
                var ctrlA = control.ctrlA.set[ctrlADist];
                var ctrlAFromAllowed = control.ctrlA.allowed.entries.filter(function (obj) {
                    return obj.id === ctrlA.id;
                })[0];

                if (ctrlAFromAllowed) {
                    if (ctrlA.factor) {
                        ctrlAFromAllowed.factor = ctrlA.factor;
                    }
                    temp.push(ctrlAFromAllowed);
                }
            }
            control.ctrlA.set = temp;
        }
        if (control.ctrlB) {
            temp = [];
            for (var ctrlBDist = 0; ctrlBDist < control.ctrlB.set.length; ctrlBDist++) {
                var ctrlB = control.ctrlB.set[ctrlBDist];
                var ctrlBFromAllowed = control.ctrlB.allowed.entries.filter(function (obj) {
                    return obj.id === ctrlB.id;
                })[0];

                if (ctrlBFromAllowed) {
                    if (ctrlB.factor) {
                        ctrlBFromAllowed.factor = ctrlB.factor;
                    }
                    temp.push(ctrlBFromAllowed);
                }
            }
            control.ctrlB.set = temp;
        }
        if (control.ctrlC) {
            temp = [];
            for (var ctrlCDist = 0; ctrlCDist < control.ctrlC.set.length; ctrlCDist++) {
                var ctrlC = control.ctrlC.set[ctrlCDist];
                var ctrlCFromAllowed = control.ctrlC.allowed.entries.filter(function (obj) {
                    return obj.id === ctrlC.id;
                })[0];

                if (ctrlCFromAllowed) {
                    if (ctrlC.factor) {
                        ctrlCFromAllowed.factor = ctrlC.factor;
                    }
                    temp.push(ctrlCFromAllowed);
                }
            }
            control.ctrlC.set = temp;
        }
        if (control.ctrlD) {
            temp = [];
            for (var ctrlDDist = 0; ctrlDDist < control.ctrlD.set.length; ctrlDDist++) {
                var ctrlD = control.ctrlD.set[ctrlDDist];
                var ctrlDFromAllowed = control.ctrlD.allowed.entries.filter(function (obj) {
                    return obj.id === ctrlD.id;
                })[0];

                if (ctrlDFromAllowed) {
                    if (ctrlD.factor) {
                        ctrlDFromAllowed.factor = ctrlD.factor;
                    }
                    temp.push(ctrlDFromAllowed);
                }
            }
            control.ctrlD.set = temp;
        }
        if (control.crd) {
            temp = [];
            for (var crdDist = 0; crdDist < control.crd.set.length; crdDist++) {
                var crd = control.crd.set[crdDist];
                var crdFromAllowed = control.crd.allowed.entries.filter(function (obj) {
                    return obj.id === crd.id;
                })[0];

                if (crdFromAllowed) {
                    if (crd.factor) {
                        crdFromAllowed.factor = crd.factor;
                    }
                    temp.push(crdFromAllowed);
                }
            }
            control.crd.set = temp;
        }
        if (control.psp) {
            temp = [];
            for (var pspDist = 0; pspDist < control.psp.set.length; pspDist++) {
                var psp = control.psp.set[pspDist];
                var pspFromAllowed = control.psp.allowed.entries.filter(function (obj) {
                    return obj.id === psp.id;
                })[0];

                if (pspFromAllowed) {
                    if (psp.factor) {
                        pspFromAllowed.factor = psp.factor;
                    }
                    temp.push(pspFromAllowed);
                }
            }
            control.psp.set = temp;
        }
        if (control.act) {
            temp = [];
            for (var actDist = 0; actDist < control.act.set.length; actDist++) {
                var act = control.act.set[actDist];
                var actFromAllowed = control.act.allowed.entries.filter(function (obj) {
                    return obj.id === act.id;
                })[0];

                if (actFromAllowed) {
                    if (act.factor) {
                        actFromAllowed.factor = act.factor;
                    }
                    temp.push(actFromAllowed);
                }
            }
            control.act.set = temp;
        }
        if (control.net) {
            temp = [];
            for (var netDist = 0; netDist < control.net.set.length; netDist++) {
                var net = control.net.set[netDist];
                var netFromAllowed = control.net.allowed.entries.filter(function (obj) {
                    return obj.id === net.id;
                })[0];

                if (netFromAllowed) {
                    if (net.factor) {
                        netFromAllowed.factor = net.factor;
                    }
                    temp.push(netFromAllowed);
                }
            }
            control.net.set = temp;
        }
        if (control.asn) {
            temp = [];
            for (var asnDist = 0; asnDist < control.asn.set.length; asnDist++) {
                var asn = control.asn.set[asnDist];
                var asnFromAllowed = control.asn.allowed.entries.filter(function (obj) {
                    return obj.id === asn.id;
                })[0];

                if (asnFromAllowed) {
                    if (asn.factor) {
                        asnFromAllowed.factor = asn.factor;
                    }
                    temp.push(asnFromAllowed);
                }
            }
            control.asn.set = temp;
        }
        if (control.ino) {
            temp = [];
            for (var inoDist = 0; inoDist < control.ino.set.length; inoDist++) {
                var ino = control.ino.set[inoDist];
                var inoFromAllowed = control.ino.allowed.entries.filter(function (obj) {
                    return obj.id === ino.id;
                })[0];

                if (inoFromAllowed) {
                    if (ino.factor) {
                        inoFromAllowed.factor = ino.factor;
                    }
                    temp.push(inoFromAllowed);
                }
            }
            control.ino.set = temp;
        }
        if (control.loc) {
            temp = [];
            for (var locDist = 0; locDist < control.loc.set.length; locDist++) {
                var loc = control.loc.set[locDist];
                var locFromAllowed = control.loc.allowed.entries.filter(function (obj) {
                    return obj.id === loc.id;
                })[0];

                if (locFromAllowed) {
                    if (loc.factor) {
                        locFromAllowed.factor = loc.factor;
                    }
                    temp.push(locFromAllowed);
                }
            }
            control.loc.set = temp;
        }
        if (control.eko) {
            temp = [];
            for (var ekoDist = 0; ekoDist < control.eko.set.length; ekoDist++) {
                var eko = control.eko.set[ekoDist];
                var ekoFromAllowed = control.eko.allowed.entries.filter(function (obj) {
                    return obj.id === eko.id;
                })[0];

                if (ekoFromAllowed) {
                    if (eko.factor) {
                        ekoFromAllowed.factor = eko.factor;
                    }
                    temp.push(ekoFromAllowed);
                }
            }
            control.eko.set = temp;
        }
        if (control.ekg) {
            temp = [];
            for (var ekgDist = 0; ekgDist < control.ekg.set.length; ekgDist++) {
                var ekg = control.ekg.set[ekgDist];
                var ekgFromAllowed = control.ekg.allowed.entries.filter(function (obj) {
                    return obj.id === ekg.id;
                })[0];

                if (ekgFromAllowed) {
                    if (ekg.factor) {
                        ekgFromAllowed.factor = ekg.factor;
                    }
                    temp.push(ekgFromAllowed);
                }
            }
            control.ekg.set = temp;
        }
    }
};

